export default __webpack_public_path__ + "static/media/logo-list-diprom.65878204.png";